// import moment from 'moment';
import React from 'react'
import Modal from 'react-modal'
import { useNavigate } from 'react-router-dom';
import { serializeQueryStrings } from '../../utils';
import DocketRequestsFilterForm from '../LCO/Forms/DocketRequestsFilterForm';
// import { toast } from 'react-toastify';
// import { useFindCircuit } from '../../hooks/circuit';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '700px',
    },
    overlay: { zIndex: 1000 }
};
export default function DocketRequestsFilterModal({ modal, setModal, searchParams, setSearchParams }) {
    let navigate = useNavigate();

    const handleSubmit = async (values) => {
        // Reset pagination when applying filters
        const filteredValues = { ...values, skip: undefined };
        setSearchParams(serializeQueryStrings(filteredValues))
        setModal(false)
    }
    const resetFrom = (formik) => {
        formik.resetForm()
        navigate(`/docket/requests`)
        setModal(false)
    }
    return (
        <Modal
            isOpen={modal}
            style={customStyles}
            contentLabel="Example Modal"
        >
            <div className="container-fluid">

                <div className="d-flex justify-content-between">
                    <h5 className="modal-title mb-3 text-center text-info">Filter Docket Requests</h5>
                    <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close" onClick={() => setModal(false)}></button>
                </div>
                <div className="modal-body" style={{ width: '100%' }}>
                    <DocketRequestsFilterForm
                        isLoading={false}
                        handleSubmit={handleSubmit}
                        setModal={setModal}
                        resetFrom={resetFrom}
                        searchParams={searchParams}
                    />
                </div>
            </div>
        </Modal>
    )
}
